module.exports = __webpack_public_path__ + "img/axe.salvaged.83af9899.png";